import React, {PropTypes} from "react";
import {NavItem} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";
import Drawer from "material-ui/Drawer";
import MenuItems from "material-ui/MenuItem";
import Menu from "material-ui/Menu";
import AppBar from "material-ui/AppBar";
import Divider from "material-ui/Divider";
import {hashHistory} from "react-router";


class Mainnav extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount(){
      let menuItems, leaveItems;
    if (this.props.isManager) {
      menuItems = [
        <MenuItems insetChildren onClick={()=> {
          hashHistory.push("/1/attendance/myAttendance");
          this.props.handleClose();
        }} primaryText="My Attendance"/>, <MenuItems insetChildren onClick={()=> {
          hashHistory.push("/1/attendance/myAttendanceRegularisation");
          this.props.handleClose();
        }} primaryText="My Regularisation"/>,
        <MenuItems insetChildren onClick={()=> {
          hashHistory.push("/1/attendance/team");
          this.props.handleClose();
        }}
                   primaryText="Team Attendance"/>,
        <MenuItems insetChildren onClick={()=> {
          hashHistory.push("/1/attendance/teamRegularisation");
          this.props.handleClose();
        }} primaryText="Team Regularisation"/>,

      ];
      leaveItems = [

        <MenuItems insetChildren onClick={()=> {
          hashHistory.push("/1/leave/apply");
          this.props.handleClose();
        }} primaryText="Apply Leave"/>, <MenuItems insetChildren onClick={()=> {
          hashHistory.push("/1/leave/history");
          this.props.handleClose();
        }} primaryText="Leave History"/>,
        <MenuItems insetChildren onClick={()=> {
          hashHistory.push("/1/leave/team");
          this.props.handleClose();
        }} primaryText="Team Leave"/>, <MenuItems insetChildren onClick={()=> {
          hashHistory.push("/1/leave/teamhistory");
          this.props.handleClose();
        }} primaryText="Team Leave History"/>

      ];

    }
    else {
      menuItems = [
        <MenuItems insetChildren onClick={()=> {
          hashHistory.push("/1/attendance/myAttendance");
          this.props.handleClose();
        }} primaryText="My Attendance"/>, <MenuItems insetChildren onClick={()=> {
          hashHistory.push("/1/attendance/myAttendanceRegularisation");
          this.props.handleClose();
        }} primaryText="My Regularisation"/>,
      ];
      leaveItems = [

        <MenuItems insetChildren onClick={()=> {
          hashHistory.push("/1/leave/apply");
          this.props.handleClose();
        }} primaryText="Apply Leave"/>, <MenuItems insetChildren onClick={()=> {
          hashHistory.push("/1/leave/history");
          this.props.handleClose();
        }} primaryText="Leave History"/>,
      ];

    }
    this.props.saveMenuItem(menuItems);
    this.props.saveLeaveItem(leaveItems);
  }

  showHrAdminTab() {
      let empRoles = this.props.permission;
      if(empRoles.hr) {
          if (empRoles.peopleSearch || empRoles.exits || empRoles.exitsFnF || empRoles.onBoarding ||
              empRoles.onBoardingExpected || empRoles.leave || empRoles.upload || empRoles.download || empRoles.ctcSplit) {
              return true;
          } else {
              return false;
          }
      } else {
        return false;
      }
  }

  render() {
    if(this.props.permission.function!=null)
    return (
      <div id="navigationbar" style={{position: 'static', width: '100%'}}>

        <div style={{'zIndex': '5'}} className="navbar nav-bg collapse navbar-collapse nav-menu">
          <span className="close-icon hidden">X</span>
          <div className="search-link hidden"></div>
          <ul className="nav navbar-nav">
            <ul className="nav navbar-nav">
              <NavItem className="x" style={{width: '40px'}} onClick={()=> {
                this.props.handleToggle();
              }}>
                <img style={{height: '20px'}} src="/public/images/menu.png"/>
              </NavItem>
            </ul>

            <LinkContainer to="/1/home">
              <NavItem>Home</NavItem>
            </LinkContainer>
            <LinkContainer to="/1/attendance">
              <NavItem>Attendance</NavItem>
            </LinkContainer>
            <LinkContainer to="/1/leave">
              <NavItem>Leave</NavItem>
            </LinkContainer>
            <LinkContainer to="/1/myProfile">
              <NavItem>My Profile</NavItem>
            </LinkContainer>
             <LinkContainer to="/1/announcements">
              <NavItem>Announcements</NavItem>
            </LinkContainer>


            <LinkContainer to="/1/policy">
              <NavItem>Policies</NavItem>
            </LinkContainer>

            {/*<LinkContainer to="/1/policy1/myPolicy">*/}
              {/*<NavItem>My Policy</NavItem>*/}
            {/*</LinkContainer>*/}


            {(this.props.permission.function == 'Sales' || this.props.permission.function=='TeleSales' ||
            this.props.permission.function=='MGMT' || this.props.permission.function=='Operations' ||
            this.props.permission.function=='Sales Operations' || this.props.permission.function=='Beauty'
            || this.props.permission.function=='Product') ? <LinkContainer to="/1/qcap">
              <NavItem>QCAP</NavItem>
            </LinkContainer> : null}
            {this.showHrAdminTab() ? <LinkContainer to="/1/admin">
              <NavItem>HR Admin</NavItem>
            </LinkContainer> : null}
            {this.props.permission.hrbp ? <LinkContainer to="/1/hrbp">
              <NavItem>HRBP</NavItem>
            </LinkContainer> : null}
            {this.props.permission.it ? <LinkContainer to="/1/it">
              <NavItem>IT</NavItem>
            </LinkContainer> : null}
            {this.props.permission.finance ? <LinkContainer to="/1/finance">
              <NavItem>Finance</NavItem>
            </LinkContainer> : null}

            {this.props.permission.admin ? <LinkContainer to="/1/administrator">
              <NavItem>Facilities</NavItem>
            </LinkContainer> : null}
            {this.props.permission.recruiter ?
              <LinkContainer to="/1/recruiter">
                <NavItem>Recruiter</NavItem>
              </LinkContainer> : null}

            {/*this.props.permission.hr ?
              <LinkContainer to="/1/referral">
                <NavItem>Referral</NavItem>
              </LinkContainer> : null*/}

            <LinkContainer to="/1/feedback">
              <NavItem>Feedback</NavItem>
            </LinkContainer>



          </ul>
        </div>

      </div>

    );
    else return <div></div>;

  }
}

Mainnav.propTypes = {
  roles: React.PropTypes.object

};

export default Mainnav;



/** WEBPACK FOOTER **
 ** ./src/components/TopNavigation/Mainnav.js
 **/